import React from 'react';
import MuiButton from '@material-ui/core/Button';

import Loader from '../Loader/Spinner/Spinner';
import './Button.scss';

const Button = props => {
  const { testId, buttonStyle, disabled, onClick, size, fullWidth, className, type, loading, children } = props;
  const style = buttonStyle || 'primary';
  const { buttonColorStyle } = props;
  let variant;
  let color;
  let spinnerColor;
  if (style === 'primary') {
    variant = 'contained';
    color = 'primary';
    spinnerColor = 'inherit';
  } else if (style === 'secondary') {
    variant = 'outlined';
    color = 'primary';
    spinnerColor = 'inherit';
  } else if (style === 'destructive') {
    variant = 'outlined';
    color = 'primary';
    spinnerColor = 'inherit';
  } else if (style === 'text') {
    variant = 'text';
    color = 'primary';
    spinnerColor = 'inherit';
  }

  return (
    <MuiButton
      data-testid={testId}
      disabled={disabled}
      onClick={onClick}
      size={size}
      fullWidth={fullWidth}
      classes={{
        root: `rsa-button rsa-style-${style} ${className || ''}`,
        label: 'rsa-button-label'
      }}
      variant={variant}
      color={buttonColorStyle || color}
      type={type}
    >
      {loading && <Loader size="sm" color={spinnerColor} />}
      {children}
    </MuiButton>
  );
};

export default Button;
